import A11yDialog from 'a11y-dialog'

document.querySelectorAll('.modalContainer').forEach(function (thisDialog) {
    const id = thisDialog.id; // make sure your modalContainer element has a unique ID
    const container = document.getElementById(id)
    const initDialog = new A11yDialog(container)
    console.log(initDialog)

    document.addEventListener("DOMContentLoaded", (event) => {
        // @BE hook up to cookie
        initDialog.show();
    });

});